export const BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL;
export const CHAT_BASE_URL = process.env.NEXT_PUBLIC_CHAT_BASE_URL;
export const reverbAuthUrl = `${BASE_URL}broadcast/reverb/auth`;

// Login
export const urlReset = `${BASE_URL}`;
export const loginUrl = `${BASE_URL}auth/login/login`;
export const resetPasswordAccount = `${BASE_URL}auth/login/update-password-logged-user`;
export const refreshToken = `${BASE_URL}auth/login/refresh`;
export const recoverPassword = `${BASE_URL}auth/login/recover`;
export const recoverPasswordCurrent = `${BASE_URL}suppliers/users/update-password`;
export const registerUser = `${BASE_URL}auth/login/register-user`;
export const assignUser = `${BASE_URL}suppliers/customers/assign-user`;
export const usersAll = `${BASE_URL}suppliers/users/all`;
export const qrLoginCreate = `${BASE_URL}auth/login/qr-login/create`;

// Customers
export const customersUrl = `${BASE_URL}suppliers/customers/all`;
export const customersInactiveUrl = `${BASE_URL}suppliers/customers/all?inactive=true`;
export const customersPendingUrl = `${BASE_URL}suppliers/customers/pending`;
export const createCustomer = `${BASE_URL}suppliers/customers/create`;
export const groupsUrl = `${BASE_URL}suppliers/hqs/all`;
export const subGroupsUrl = `${BASE_URL}suppliers/subgroups/all`;
export const customersData = `${BASE_URL}suppliers/customers/search`;
export const customerUpdate = `${BASE_URL}suppliers/customers/update/`;
export const customerPromoteUrl = `${BASE_URL}suppliers/customers/`;
export const updateColabPriceList = `${BASE_URL}external/price-list/update-in-api`;
export const plasticCratesBalancesUrl = `${BASE_URL}suppliers/plastic-crates/balances`;
export const toggleFlagVipCratesUrl = `${BASE_URL}suppliers/customers/toggle-flag/`;
export const crateMovementsUrl = `${BASE_URL}suppliers/plastic-crates/movements`;
export const crateResetBalanceUrl = `${BASE_URL}suppliers/plastic-crates/reset-balance`;
export const crateInlineUpdateUrl = `${BASE_URL}suppliers/plastic-crates/inline-update`;
export const crateCustomerUrl = `${BASE_URL}suppliers/plastic-crates/customer/`;

// Routes

export const routesUrl = `${BASE_URL}suppliers/routes/all`;
export const createRouteUrl = `${BASE_URL}suppliers/routes/create`;
export const updateRouteUrl = `${BASE_URL}suppliers/routes/update/`;
export const deleteRouteUrl = `${BASE_URL}suppliers/routes/delete/`;

// Inventory
export const addMasterProduct = `${BASE_URL}suppliers/master-products/create`;
export const editMasterProduct = `${BASE_URL}suppliers/master-products/update/`;
export const productShowId = `${BASE_URL}suppliers/master-products/show/`;
export const allMasterProducts = `${BASE_URL}suppliers/master-products/list`;
export const deleteMasterProductUrl = `${BASE_URL}suppliers/master-products/delete/`;
export const getMasterProductsExtended = `${BASE_URL}suppliers/products-extended-information/all`;
export const getMasterProductsExtendedType = `${BASE_URL}suppliers/products-extended-information/type`;

export const addProduct = `${BASE_URL}suppliers/products-suppliers/create`;
export const productsSplitsSearch = `${BASE_URL}suppliers/products-suppliers/all-subproducts/`;
export const parentProductsAll = `${BASE_URL}suppliers/products-suppliers/all-products`;
export const productsSuppliersMasters = `${BASE_URL}suppliers/products-suppliers/masters`; // masters list; /{id}/variants lists a master's variants
export const measurementUnitsSelect = `${BASE_URL}suppliers/inventory-rules/units/select`; // measurement units + their conversion mode for a master (?master_product_id=)
export const editProduct = `${BASE_URL}suppliers/products-suppliers/update`;
export const detailProductUrl = `${BASE_URL}suppliers/products-suppliers/`;
export const deleteProductUrl = `${BASE_URL}suppliers/products-suppliers/delete`;
export const masterProductsAll = `${BASE_URL}suppliers/master-products/all`;
export const MergeMasterProducts = `${BASE_URL}suppliers/products-suppliers/merge/master-product`;
export const locationWHouse = `${BASE_URL}suppliers/locations/location-by-supplier`; // También se usa en database -> locations
export const typeDetailsUrl = `${BASE_URL}suppliers/types_details/all`;
export const unitOfSalesUrl = `${BASE_URL}suppliers/products-suppliers/units-of-sales/all`;
export const sendNewUnitOfSalesUrl = `${BASE_URL}suppliers/units-of-sales/create`;
export const generateImageAI = `${BASE_URL}ai-integrations/openai-api/generate-image`;

export const getConversions = `${BASE_URL}suppliers/products-suppliers/verticals/`;
export const producstByMaster = `${BASE_URL}suppliers/products-suppliers/by-master-product/`;
export const auditLogsProducts = `${BASE_URL}suppliers/audit/logs/products_suppliers/`;
export const auditLogsMasterProducts = `${BASE_URL}suppliers/audit/logs/master_products/`;


// Operations - Stop
export const operationsStopsUrl = `${BASE_URL}suppliers/operations-stops`;
export const operationsStopsReportUrl = `${BASE_URL}suppliers/operations-stops/report`;
export const operationsStopsCustomerUrl = `${BASE_URL}suppliers/operations-stops/customer`;
export const changeMovStateUrl = `${BASE_URL}suppliers/orders/change-mov-state`;

// Commons
export const categoriesUrl = `${BASE_URL}suppliers/categories/all`;
export const uomUrl = `${BASE_URL}suppliers/uoms/all`;
export const typesUrl = `${BASE_URL}suppliers/types/all`;
export const taxUrl = `${BASE_URL}suppliers/taxes/all`;
export const dateAvailable = `${BASE_URL}suppliers/operations/history`;
export const getCountry = `${BASE_URL}suppliers/taxes/get-countries`;

// Categories
export const createCategory = `${BASE_URL}suppliers/categories/create`;
export const deleteCategory = `${BASE_URL}suppliers/categories/delete/`;
export const editCategory = `${BASE_URL}suppliers/categories/update/`;

// Departments
export const getDepartments = `${BASE_URL}suppliers/department-supplier/all`;
export const createDepartment = `${BASE_URL}suppliers/department-supplier/create`;
export const deleteDepartment = `${BASE_URL}suppliers/department-supplier/delete/`;
export const editDepartment = `${BASE_URL}suppliers/department-supplier/update/`;

// Query Types
export const getQueryTypes = `${BASE_URL}suppliers/query-types/all`;
export const createQueryType = `${BASE_URL}suppliers/query-types/create`;
export const deleteQueryType = `${BASE_URL}suppliers/query-types/delete/`;
export const editQueryType = `${BASE_URL}suppliers/query-types/update/`;

// Types
export const createType = `${BASE_URL}suppliers/types/create`;
export const deleteType = `${BASE_URL}suppliers/types/`;
export const editType = `${BASE_URL}suppliers/types/`;

// Locations
export const createLocation = `${BASE_URL}suppliers/locations/create-location`;
export const editLocation = `${BASE_URL}suppliers/locations/`;
export const deleteLocation = `${BASE_URL}suppliers/locations/`;

// Customer HQ
export const getCustomerHq = `${BASE_URL}suppliers/hqs/all`;
export const createCustomerHq = `${BASE_URL}suppliers/hqs/create/ `;
export const editCustomerHq = `${BASE_URL}suppliers/hqs/update/`;
export const deleteCustomerHq = `${BASE_URL}suppliers/hqs/delete/`;

// Taxes
export const getTaxes = `${BASE_URL}suppliers/taxes/all`;
export const createTaxes = `${BASE_URL}suppliers/taxes/create/ `;
export const editTaxes = `${BASE_URL}suppliers/taxes/update/`;
export const deleteTaxes = `${BASE_URL}suppliers/taxes/delete/`;

// Tags
export const getTags = `${BASE_URL}suppliers/tag/all`;
export const createTags = `${BASE_URL}suppliers/tag/create`;
export const updateTags = `${BASE_URL}suppliers/tag/update/`;
export const deleteTags = `${BASE_URL}suppliers/tag/delete/`;

// UOS
export const getUos = `${BASE_URL}suppliers/units-of-sales/all`;
export const createUos = `${BASE_URL}suppliers/units-of-sales/create `;
export const editUos = `${BASE_URL}suppliers/units-of-sales/update/`;
export const deleteUos = `${BASE_URL}suppliers/units-of-sales/delete/`;

// Warehouse
export const getWarehouse = `${BASE_URL}suppliers/warehouse/all`;
export const createWarehouse = `${BASE_URL}suppliers/warehouse/create `;
export const editWarehouse = `${BASE_URL}suppliers/warehouse/update/`;
export const deleteWarehouse = `${BASE_URL}suppliers/warehouse/delete/`;

// Adjustment Reasons
export const getAdjustmentReasons = `${BASE_URL}suppliers/adjustment-reasons/all`;
export const createAdjustmentReasons = `${BASE_URL}suppliers/adjustment-reasons/create `;
export const editAdjustmentReasons = `${BASE_URL}suppliers/adjustment-reasons/update/`;
export const deleteAdjustmentReasons = `${BASE_URL}suppliers/adjustment-reasons/delete/`;

// Credit Reasons
export const getCreditReasons = `${BASE_URL}suppliers/credit-reasons/all`;
export const createCreditReasons = `${BASE_URL}suppliers/credit-reasons/create `;
export const editCreditReasons = `${BASE_URL}suppliers/credit-reasons/update/`;
export const deleteCreditReasons = `${BASE_URL}suppliers/credit-reasons/delete/`;

// Supplier Return Reasons
export const getSupplierReturnReasons = `${BASE_URL}suppliers/supplier-return-reasons/all`;
export const createSupplierReturnReasons = `${BASE_URL}suppliers/supplier-return-reasons/create `;
export const editSupplierReturnReasons = `${BASE_URL}suppliers/supplier-return-reasons/update/`;
export const deleteSupplierReturnReasons = `${BASE_URL}suppliers/supplier-return-reasons/delete/`;

// Supplier
export const getSupplierAll = `${BASE_URL}suppliers/supplier/all`;
export const getSupplierOne = `${BASE_URL}suppliers/supplier/supplier`;
export const createSupplier = `${BASE_URL}suppliers/supplier/create-supplier`;
export const editSupplier = `${BASE_URL}suppliers/supplier/update`;
export const deleteSupplier = `${BASE_URL}suppliers/supplier/delete/`;
export const getDocuments = `${BASE_URL}documents/show/`;
export const postDocuments = `${BASE_URL}documents/store/`;
export const deleteDocuments = `${BASE_URL}documents/delete/`;
export const getTypesDocs = `${BASE_URL}documents/type/index`;
export const updateDocuments = `${BASE_URL}documents/update/`;

// Orders
export const ordersDate = `${BASE_URL}suppliers/orders/searchDate`;
export const allProducts = `${BASE_URL}suppliers/products-suppliers/all`; // este enpoint tambien se usa en catalogue
export const allVisibleSalesPurchaseProducts = `${BASE_URL}suppliers/products-suppliers/all-visible-sales-purchase`;
export const productsCustomer = `${BASE_URL}suppliers/products-accounts/all`;
export const orderDetail = `${BASE_URL}suppliers/orders/`;
export const createStorageOrder = `${BASE_URL}suppliers/orders/create`;
export const editStorageOrder = `${BASE_URL}suppliers/orders/update/`;
export const updateStatePosted = `${BASE_URL}suppliers/orders/update-state`;
export const deleteOrder = `${BASE_URL}suppliers/orders/delete`;
export const uploadCsv = `${BASE_URL}suppliers/orders/upload-csv`;
export const uploadPdf = `${BASE_URL}openai/email-orders/order-pdf `;
export const printCreditNote = `${BASE_URL}suppliers/invoice/credit-note/generate`;
export const orderCSV2 = `${BASE_URL}suppliers/orders/export/csv-vat`;
export const statesUrl = `${BASE_URL}suppliers/orders/states`;
export const updateReleased = `${BASE_URL}suppliers/orders/update-status-released`;
export const updateStatus = `${BASE_URL}suppliers/short/update`;
export const despatchUpdate = `${BASE_URL}suppliers/orders/update-quantity`;
export const getInfoCustomer = `${BASE_URL}suppliers/customers/search-route-default`;
export const updateDiscount = `${BASE_URL}suppliers/customers/update-amount-discounted`;
export const sendEmails = `${BASE_URL}suppliers/invoice/send-email`;
export const mappingProducts = `${BASE_URL}suppliers/products-mapping/add-data-mapping-csv`;
export const pricesOrder = `${BASE_URL}suppliers/orders/update-price-for-order`;
export const updateCost = `${BASE_URL}suppliers/orders/update-cost`;
export const updateTypeOrder = `${BASE_URL}suppliers/orders/update-order-type`;
export const updatePricesOrder = `${BASE_URL}suppliers/orders/update-price-for-order/`;
export const sendMailgunEmails = `${BASE_URL}suppliers/invoice/pdf/send-email`;
export const getProductsHistory = `${BASE_URL}suppliers/product-history/get-history`;
export const apiBot = `${CHAT_BASE_URL}/bot/api/download-csv`;
export const deleteWarning = `${BASE_URL}suppliers/orders/delete-warning`;
export const printExternal = `${BASE_URL}suppliers/invoice/generate/external-print`;
export const bulkPrint = `${BASE_URL}suppliers/invoice/generate/external-print/zip`;
export const botAmendmentsOrders = `https://api.grownetapp.com/bot/api/amendments-by-ids`;
export const rollbackOrder = `${BASE_URL}suppliers/orders/rollback`;
export const auditLogsOrders = `${BASE_URL}suppliers/audit/logs/orders/`;
export const auditLogsDetailOrders = `${BASE_URL}suppliers/audit/logs/detail_orders/`;
export const auditLogsPurchaseOrders = `${BASE_URL}suppliers/audit/logs/purchase_orders/`;
export const auditLogsPologWholesalers = `${BASE_URL}suppliers/audit/logs/polog_wholesalers/`;
export const auditLogsPoInvoices = `${BASE_URL}suppliers/audit/logs/po_invoices/`;


// Amendments
export const apiBotUFCAmendments = `${CHAT_BASE_URL}/bot/api/process-amendments-UFC`;
export const apiBotEfAmendments = `${CHAT_BASE_URL}/bot/api/process-amendments-EF`;
export const apiBotAmendmentsRequisitions = `${CHAT_BASE_URL}/bot/api/amendments-by-filter-ids`;

// Emails

export const getAllEmailsLogs = `${BASE_URL}suppliers/invoice/directMarket/`;
// Email Logs
export const getCommunicationHistory = `${BASE_URL}mail/mailgun/get-communication-history`;

// Substitutes
export const substitutesUrl = `${BASE_URL}suppliers/substitutes/all?date=`;
export const substitutesByProduct = `${BASE_URL}suppliers/substitutes/ByProduct?date=`;
export const updateSubstitute = `${BASE_URL}suppliers/substitutes/update`;

// Day management
export const closeDay = `${BASE_URL}suppliers/operations/end`;

// Wholesalers
export const wholesalersUrl = `${BASE_URL}suppliers/wholesalers/all`;
export const createWholesalers = `${BASE_URL}suppliers/wholesalers/create`;
export const updateWholesalerStatus = `${BASE_URL}suppliers/wholesalers/change-status/`;
export const editWholesaler = `${BASE_URL}suppliers/wholesalers/update/`;
export const showWholesaler = `${BASE_URL}suppliers/wholesalers/show/`;

// Purchasing
export const purchasingUrl = `${BASE_URL}suppliers/purchasing/purchase-list`;
export const purchasingAll = `${BASE_URL}suppliers/purchasing/purchase-list-all`;
export const createPO = `${BASE_URL}suppliers/purchasing/quick-purchase-order`;
export const purchaseDetail = `${BASE_URL}suppliers/products-suppliers/products-orders/`;
export const purchaseOrderProducts = `${BASE_URL}suppliers/purchasing/products-orders/`;
export const productOptions = `${BASE_URL}suppliers/purchasing/get-products`;
export const changeStatusPO = `${BASE_URL}suppliers/purchasing/invoice/update-order-type`;
export const emailsPurchaseUrl = `${BASE_URL}suppliers/purchasing-ai/email-orders`;
export const matchEmail = `${BASE_URL}suppliers/purchasing-ai/match-order`;
export const lastPurchase = `${BASE_URL}suppliers/purchasing/last-purchases-products`;
export const lastPurchasesDetails = `${BASE_URL}suppliers/purchasing/last-purchases-details`;
export const getOrdersByProductAndCategory = `${BASE_URL}suppliers/orders/get-orders-products-by-date-and-category`;
export const storeInvoice = `${BASE_URL}suppliers/purchasing/store-invoice`;
export const getInvoicesByDate = `${BASE_URL}suppliers/purchasing/get-invoices-by-date`;
export const getPostedByDate = `${BASE_URL}suppliers/purchasing/get-invoices-by-date/posted`;
export const sendPdfEmailPO = `${BASE_URL}suppliers/invoice/purchase/send-email`;
export const getInvoicesByStatus = `${BASE_URL}suppliers/purchasing/get-invoices-by-status?status=`;
export const addInvoice = `${BASE_URL}suppliers/purchasing/update-invoice/`;
export const productsByCustomer = `${BASE_URL}suppliers/purchasing/check-product-by-customer/`;
export const updateStatusPO = `${BASE_URL}suppliers/purchasing/update-state-order`;
export const updatePurchasesOrderType = `${BASE_URL}suppliers/purchasing/update-order-type`;
export const getPOCart = `${BASE_URL}suppliers/purchasing/purchase-orders-cart`;
export const editInvoiceUrl = `${BASE_URL}suppliers/purchasing/update-invoice-all/`;
export const deleteInvoiceUrl = `${BASE_URL}suppliers/purchasing/delete-invoice/`;
export const downloadPOCSV = `${BASE_URL}suppliers/purchasing/export-csv`;
export const searchPurchasingUrl = `${BASE_URL}suppliers/purchasing/search`;
export const printPurchases = `${BASE_URL}suppliers/invoice/generate/purchase-order`;

//contracts
export const contractsUrl = `${BASE_URL}suppliers/wholesalers/contracts`;
export const createContracts = `${BASE_URL}suppliers/wholesalers/contracts/create`;
export const updateContracts = `${BASE_URL}suppliers/wholesalers/contracts/update`;
export const detailsContracts = `${BASE_URL}suppliers/wholesalers/contracts/show`;
export const checkProductContracts = `${BASE_URL}suppliers/wholesalers/contracts/check`;

// Supplier Returns
//--> add supplier returns
export const productsByWholesaler = `${BASE_URL}suppliers/purchase-order-credit-notes/info-products-for-wholesalers/`;

// Order History
export const purchaseOrderRequest = `${BASE_URL}suppliers/purchasing/purchase-orders-and-sales-tickets-by-date`;
export const purchaseOrderDetail = `${BASE_URL}suppliers/purchasing/order-details/`;
export const purchaseInvoiceDetail = `${BASE_URL}suppliers/purchasing/detail-invoice/`;
export const purchaseOrderEvidencesUrl = `${BASE_URL}suppliers/purchasing/evidences/`;
export const purchaseOrderEvidenceDetailUrl = `${purchaseOrderEvidencesUrl}detail/`;
export const purchaseOrderReceptionUrl = `${BASE_URL}suppliers/purchasing/reception/`;
export const updatePurchaseOrder = `${BASE_URL}suppliers/purchasing/update-values-reception`;
export const updatePurchaseOrderPO = `${BASE_URL}suppliers/purchasing/add-product-po/`;

// Delivery History
export const routesByDate = `${BASE_URL}suppliers/routes/delivery-history`;
export const assignRoute = `${BASE_URL}suppliers/logistic-routes/assignRoute`;
export const vehiclesAndDrivers = `${BASE_URL}suppliers/delivery-routes/vehicles-employees`;
export const dieselCardsUrl = `${BASE_URL}suppliers/cards/all`;
// Dynamic routes
export const dynamicRoutesUrl = `${BASE_URL}suppliers/dynamic-routes/all`;
export const updateDynamicRoutes = `${BASE_URL}suppliers/logistic-routes/transport/dynamic-routes`;
export const refreshLogistic = `${BASE_URL}suppliers/logistic-routes/update-logistics-routes`;
export const updateLogisticRoute = `${BASE_URL}suppliers/logistic-routes/update-route`;

// Static routes
export const staticRoutesUrl = `${BASE_URL}suppliers/static-routes/all`;
export const updateStaticRoutes = `${BASE_URL}suppliers/static-routes`;
export const detailsRoutesCard = `${BASE_URL}suppliers/static-routes/additional-data`;
export const getRoutingCustomerUrl = `${BASE_URL}suppliers/customers/get-routing/`;
export const editRoutingCustomerUrl = `${BASE_URL}suppliers/customers/edit-routing/`;

// Dirvers records
export const driversRecordsUrl = `${BASE_URL}suppliers/fleet-checks/driver-records`;
export const driversRecordsDetail = `${BASE_URL}suppliers/fleet-checks/details-driver-records`;
export const evidencesAllUrl = `${BASE_URL}suppliers/fleet-checks/evidences-all`;
export const evidencesDetailsUrl = `${BASE_URL}suppliers/fleet-checks/details-evidences/`;

// Product status
export const productStatusUrl = `${BASE_URL}suppliers/orders/listDetailOrders`;

// Groups
export const createGroups = `${BASE_URL}suppliers/groups/store`;
export const createSubgroups = `${BASE_URL}suppliers/subgroups/create`;

// Prices
export const groupsUrlPrices = `${BASE_URL}suppliers/groups/index-for-supplier`;
export const groupsListUrl = `${BASE_URL}suppliers/groups/list`;
export const productsPrices = `${BASE_URL}suppliers/product-groups/index-for-group-list/`;
export const comparePriceListsUrl = `${BASE_URL}suppliers/product-groups/compare-price-lists`;
export const upsertProductGroupPricesUrl = `${BASE_URL}suppliers/product-groups/upsert`;
export const updatePricesGroup = `${BASE_URL}suppliers/groups/update`;
export const deletePricesGroup = `${BASE_URL}suppliers/groups/delete`;
export const deleteAssignPriceByCustomer = `${BASE_URL}suppliers/customer-groups/delete`;
export const updatePrices = `${BASE_URL}suppliers/groups/`;
export const deleteProductList = `${BASE_URL}suppliers/product-groups/delete`;
export const addProductList = `${BASE_URL}suppliers/product-groups/create`;
export const getCustomersByGroup = `${BASE_URL}suppliers/customer-groups/customers/`;
export const getCustomersWithoutGroup = `${BASE_URL}suppliers/customer-groups/customers-no-assigned`;
export const assignCustomerPriceList = `${BASE_URL}suppliers/customer-groups/assign`;
export const dynamicPricesList = `${BASE_URL}dynamics-prices/price-list`;

// Prices EFA
export const getProductsEFA = `${BASE_URL}dynamics-prices/efa/products`;
export const getProductById = `${BASE_URL}dynamics-prices/by-product/`;
export const createProductEFA = `${BASE_URL}dynamics-prices/create`;
export const finalPriceEFA = `${BASE_URL}dynamics-prices/efa/preview-final-price`;
export const recalculateProductEFA = `${BASE_URL}suppliers/groups`;

// Complaints
export const queryTypesUrl = `${BASE_URL}suppliers/complaints/query-types/all`;
export const addComplaint = `${BASE_URL}suppliers/complaints/query-complaint/create`;
export const updateComplaint = `${BASE_URL}suppliers/complaints/query-complaint/update-status/`;
export const complaintsUrl = `${BASE_URL}suppliers/complaints/query-complaint/all`;
export const statusComplaints = `${BASE_URL}suppliers/complaints/query-complaint/status-order`;
export const complaintDetail = `${BASE_URL}suppliers/complaints/query-complaint/detail/`;
export const searchComplaint = `${BASE_URL}suppliers/complaints/orders-customer`;
export const searchDepartments = `${BASE_URL}suppliers/complaints/departments-suppliers`;
export const updateMapping = `${BASE_URL}suppliers/products-mapping/add-data-mapping-order`;
export const updateEvidenceComplaint = `${BASE_URL}suppliers/complaints/update/evidence`;
export const detailsComplaints = `${BASE_URL}suppliers/complaints`;
export const deleteComplaint = `${BASE_URL}suppliers/complaints/delete/`;

// Update prices
export const updatePricesUrl = `${BASE_URL}suppliers/orders/update/price-list`;

// Zero pricing
export const zeroPricingUrl = `${BASE_URL}suppliers/product-groups/index-details-orders-zero`;
export const zeroPricingCreate = `${BASE_URL}suppliers/product-groups/update/details-zero-or-margin`;


// Zero cost
export const zeroCostUrl = `${BASE_URL}suppliers/orders/consult/zero-prices`;
export const zeroCostUpdate = `${BASE_URL}suppliers/cost-arbitrary/update`;

// Orders with IA

export const generatedEmailRequest = `${BASE_URL}openai/email-orders/get-order/`;
export const generatedEmailUpdate = `${BASE_URL}openai/email-orders/update`;
export const updateEmails = `${BASE_URL}openai/email-orders/is-order`;
export const detailEmail = `${BASE_URL}openai/email-orders/get-html/`;

// Rounds
export const roundsPercentage = `${BASE_URL}logistics/routes/percentage-packing-loading`;

// Warnings
export const fixWarning = `${BASE_URL}suppliers/products-logs/fix/`;
export const fixCost = `${BASE_URL}suppliers/products-logs/insert/cost-default`;
export const getInformation = `${BASE_URL}suppliers/orders/index/audit`;

// Settings
export const fetchRoles = `${BASE_URL}auth/roles`;
export const fetchProfiles = `${BASE_URL}auth/profiles`;
export const fetchPermissions = `${BASE_URL}auth/permissions`;
export const saveDataRoles = `${BASE_URL}auth/permissions/set-role-permissions`;
export const getAllconfigs = `${BASE_URL}configurations/configs/all`;
export const updateconfigs = `${BASE_URL}configurations/configs/update`;
export const updateAliasConfig = `${BASE_URL}configurations/configs/`;
export const allLogs = `${BASE_URL}suppliers/audit/all`;
export const allNotifications = `${BASE_URL}notifications/fcm/send-notifications`;
export const notifications = `${BASE_URL}notifications/fcm/send-notifications`;
export const disabledUser = `${BASE_URL}suppliers/users/update/state`;
export const getPermissionsByRoles = `${BASE_URL}auth/roles/permission-role-hs-docs`;
export const configsUpdatePriority = `${BASE_URL}configurations/configs/update-with-priority`;
export const clockRequired = `${BASE_URL}suppliers/users/update-clock/`;
export const createInformation = `${BASE_URL}suppliers/users/information/create`;
export const getInformationUrl = `${BASE_URL}suppliers/users/information/`;
export const updateInformation = `${BASE_URL}suppliers/users/information/update/`;
export const validatePin = `${BASE_URL}suppliers/users/validate-pin`;
export const getSkillsUrl = `${BASE_URL}suppliers/skills`;

export const getTrainings = `${BASE_URL}suppliers/hs-doc-records/training-by-user`;
export const trainingSave = `${BASE_URL}suppliers/hs-doc-records/training/save`;

// Profiles
export const fetchRolesById = `${BASE_URL}auth/profiles/roles-by-profile/`;
export const createProfileUrl = `${BASE_URL}auth/profiles/create`;
export const updateProfilesRolesPermissions = `${BASE_URL}auth/profiles/assign/profiles-roles-permissions`;
export const setHsDocRecordUrl = `${BASE_URL}auth/permissions/set-hs-doc-record`;

// Modal mapping orders
export const getProductsMapping = `${BASE_URL}suppliers/products-mapping/for-order/`;

// Profit
export const getProductProfit = `${BASE_URL}suppliers/profits/product-report`;
export const productProfitDetail = `${BASE_URL}suppliers/profits/product-detail`;
export const getCategoriesProfit = `${BASE_URL}suppliers/profits/categories`;
export const getRoutesProfit = `${BASE_URL}suppliers/profits/routes`;
export const getCustomerFinancePerformance = `${BASE_URL}suppliers/profits/customer`;

// Profit per line
export const getProfitPerLine = `${BASE_URL}suppliers/profits/order-lines-profit`;
export const getChillProfitPerLine = `${BASE_URL}suppliers/profits/profit-per-line/`;
export const markReviewed = `${BASE_URL}suppliers/product-groups/mark-price-review`;
export const listCustomers = `${BASE_URL}suppliers/customers/list`;
export const resetPricesCustomer = `${BASE_URL}suppliers/product-groups/reset-all-reviewed-prices`;

// Credit notes
export const postCreditNotes = `${BASE_URL}suppliers/order-credit-notes`;
export const postCreditNotesPurchase = `${BASE_URL}suppliers/purchase-order-credit-notes`;
export const putCreditNotes = `${BASE_URL}suppliers/order-credit-notes/`;
export const putCreditNotesPurchase = `${BASE_URL}suppliers/purchase-order-credit-notes/`;
export const AllCreditNotes = `${BASE_URL}suppliers/order-credit-notes/all`;
export const creditNoteDetail = `${BASE_URL}suppliers/order-credit-notes/`;
export const creditNotePurchaseDetail = `${BASE_URL}suppliers/purchase-order-credit-notes/`;
export const creditNotesPurchase = `${BASE_URL}suppliers/purchase-order-credit-notes/all`;
export const sendEmailCreditNote = `${BASE_URL}suppliers/order-credit-notes/pdf/send-email`;
// Approve/post a credit note — POST suppliers/order-credit-notes/{id}/change-state
export const creditNoteChangeState = `${BASE_URL}suppliers/order-credit-notes/`;

// Tender Generator
export const tendersAllUrl = `${BASE_URL}suppliers/tenders/all`;
export const createTenderUrl = `${BASE_URL}suppliers/tenders/create`;
export const createTenderItemUrl = `${BASE_URL}suppliers/tenders-items/create`;
export const compareTenderListsUrl = `${BASE_URL}suppliers/tenders-items/compare-tender-lists`;
export const upsertTenderItemPricesUrl = `${BASE_URL}suppliers/tenders-items/upsert-tender-item-prices`;
export const promoteTenderUrl = `${BASE_URL}suppliers/tenders/`;
export const importTenderCsvUrl = `${BASE_URL}suppliers/tenders/import`;
export const tenderItemsUrl = `${BASE_URL}suppliers/tenders-items/`;
export const unmapTenderItemUrl = `${BASE_URL}suppliers/tenders-items/unmap/`;
export const deleteTenderUrl = `${BASE_URL}suppliers/tenders/delete`;

// Stock
export const stockMasterProducts = `${BASE_URL}stock/products/master`;
export const stockProductsByMaster = `${BASE_URL}stock/products/productsForMaster/`;
export const inventoryList = `${BASE_URL}stock/inventory/indexForSupplier`;
export const saveStock = `${BASE_URL}stock/inventory/store`;
export const detailParentsStock = `${BASE_URL}stock/inventory/show-detail-by-master/`;
export const detailChildStock = `${BASE_URL}stock/inventory/show-detail-by-product/`;
export const updateStock = `${BASE_URL}stock/inventory/edit/`;

// Chat grownet
export const pusherKey = "cxw3ffjhnfhxqto4nobc";
export const wsHost = "prueba.grownetv2.com";
export const wsPort = 8080;
export const wssPort = 443;
export const chatsList = `${BASE_URL}whatsapp/supplier/get-all-chats`;
export const chatMessages = `${BASE_URL}whatsapp/supplier/get-messages-chat`;
export const sendChatEmail = `${CHAT_BASE_URL}/node/api/orders/send-order-ai`;
export const getMessages = `${CHAT_BASE_URL}/node/api/chats/messages`;
export const getCustomersByChat = `${CHAT_BASE_URL}/node/api/chats/get-customers-by-number`;
export const getCustomersAllInbox = `${CHAT_BASE_URL}/node/api/chats/get-customers-by-supplier/`;
export const getOptionsCreate = `${CHAT_BASE_URL}/node/api/chats/can-create/`;
export const getContacts = `${CHAT_BASE_URL}/node/api/chats/get-contacts/`;
export const changeTicketStatus = `${CHAT_BASE_URL}/node/api/inbox-tickets/change-status`;
export const getChatsByStatus = `${CHAT_BASE_URL}/node/api/inbox-tickets/get-tickets-by-status`;
export const getTeams = `${CHAT_BASE_URL}/node/api/teams/get-teams-by-supplier`;
export const getUserStatusUrl = `${CHAT_BASE_URL}/node/api/teams/get-user-status`;
export const changeAvailableStatusUrl = `${CHAT_BASE_URL}/node/api/teams/change-available-status`;
export const getUsers = `${CHAT_BASE_URL}/node/api/users/get-users`;
export const assignTicket = `${CHAT_BASE_URL}/node/api/inbox-tickets/assign-tickets`;
export const createNote = `${CHAT_BASE_URL}/node/api/inbox-internal-messages/create-note`;
export const getTeamById = `${CHAT_BASE_URL}/node/api/teams/get-team-by-id`;
export const updateTeam = `${CHAT_BASE_URL}/node/api/teams/update-team`;
export const deleteTeam = `${CHAT_BASE_URL}/node/api/teams/delete-team`;
export const createTeam = `${CHAT_BASE_URL}/node/api/teams/create`;
export const createTicket = `${CHAT_BASE_URL}/node/api/inbox-tickets/create`;
export const createWpp = `${CHAT_BASE_URL}/node/api/inbox-tickets/create-whatsapp`;
export const createGmail = `${CHAT_BASE_URL}/node/api/inbox-tickets/create-email`;
export const transcriptionUrl = `${CHAT_BASE_URL}/node/api/orders/transcript-media`;
export const createCallUrl = `${CHAT_BASE_URL}/node/api/calls/create`;
export const callToken = `${CHAT_BASE_URL}/node/api/calls/call-token`;
export const redirectCall = `${CHAT_BASE_URL}/node/api/calls/transfer-call`;
export const deleteNote = `${CHAT_BASE_URL}/node/api/inbox-internal-messages/delete-note`;

// Inbox PO
export const assignWholesaler = `${CHAT_BASE_URL}/node/api/inbox-tickets/assign-wholesalers`;
export const getWholesalers = `${CHAT_BASE_URL}/node/api/inbox-tickets/get-wholesalers`;
export const uploadPDFChat = `${BASE_URL}suppliers/purchasing/store-temp-document`;

// Schedule
export const scheduleByDate = `${BASE_URL}suppliers/schedule/scheduleByDate`;
export const scheduleStore = `${BASE_URL}suppliers/schedule/store`;
export const scheduleRoles = `${BASE_URL}suppliers/schedule/users`;
export const updateScheduleId = `${BASE_URL}suppliers/schedule`;
export const deleteScheduleId = `${BASE_URL}suppliers/schedule/delete/`;
export const statisticsSchedule = `${BASE_URL}suppliers/schedule/stats`;

// Orders history Page
export const pageOrdersHistory = `${BASE_URL}suppliers/orders/searchDateAndFilters`;

// Maps Routing
export const getIngredients = `${BASE_URL}openai/maps-places/make-request`;
export const getRoutesByDate = `${BASE_URL}suppliers/routes/information-by-date/`;
export const unassignedRoutesUrl = `${BASE_URL}suppliers/logistic-routes/shift-allocation/unassigned-routes`;
export const updateDrops = `${BASE_URL}transport/routes/update-drop`;

// Import-Export
export const importExportCustomers = `${BASE_URL}suppliers/product-groups/upload-csv-prices`;
export const validateCSVPrices = `${BASE_URL}suppliers/product-groups/validate-csv-prices`;
export const saveCSVPrices = `${BASE_URL}suppliers/product-groups/save-prices`;

// V2 Mapping / External Codes (use table products_groups_v2)
export const updatePricesV2 = `${BASE_URL}suppliers/groups/v2/`;
export const addProductListV2 = `${BASE_URL}suppliers/product-groups/v2/create`;
export const saveCSVPricesV2 = `${BASE_URL}suppliers/product-groups/v2/save-prices`;
export const updateExtInfoV2 = `${BASE_URL}suppliers/products-mapping/v2/create`;
export const addDataMappingOrderV2 = `${BASE_URL}suppliers/products-mapping/v2/add-data-mapping-order`;
export const addDataMappingCsvV2 = `${BASE_URL}suppliers/products-mapping/v2/add-data-mapping-csv`;
export const zeroPricingCreateV2 = `${BASE_URL}suppliers/product-groups/v2/update/details-zero-or-margin`;

//Production
export const getDataBOM = `${BASE_URL}suppliers/bom/get-all-data`;
export const getProductsBOM = `${BASE_URL}suppliers/bom/get-all-products`;
export const getBOMById = `${BASE_URL}suppliers/bom/get-individual-data/`;
export const createBom = `${BASE_URL}suppliers/bom/create-all-product-logic`;
export const getBomDetails = `${BASE_URL}suppliers/bom/get-bom-products`;
export const deleteMaterialsBOM = `${BASE_URL}suppliers/bom/delete-bom`;

//H&S Procedures
export const createHsProcedure = `${BASE_URL}suppliers/hs-procedures/store`;
export const getHsProceduresList = `${BASE_URL}suppliers/hs-procedures/index`;
export const getHsProceduresLight = `${BASE_URL}suppliers/hs-procedures/list`;
export const updateHsProcedure = `${BASE_URL}suppliers/hs-procedures/`;
export const getHsProcedure = `${BASE_URL}suppliers/hs-procedures/`;
export const getHsProcedureVersions = `${BASE_URL}suppliers/hs-procedures/`;
export const archiveHsProcedure = `${BASE_URL}suppliers/hs-procedures/`;
export const getHsDocRecordVersions = `${BASE_URL}suppliers/hs-doc-records/`;

//H&S
export const getReportView = `${BASE_URL}suppliers/hs-doc-records/reportView`; // Get all records
export const vehicleSurveyUrl = `${BASE_URL}suppliers/hs-doc-records/vehicle-survey`;
export const answersById = `${BASE_URL}suppliers/hs-doc-records/report/answer`; // Get answers for a specific record
export const getTemplates = `${BASE_URL}suppliers/hs-doc-records/index`; // Get templates list
export const formsUrl = `${BASE_URL}suppliers/hs-doc-records/view-form`; // Answer Form Records
export const answerFormUrl = `${BASE_URL}suppliers/hs-doc-records/answer-form`; // Answer Form Records
export const getForm = `${BASE_URL}suppliers/hs-doc-records/`; // View template by id
export const updateForm = `${BASE_URL}suppliers/hs-doc-records/`; //
export const deleteForm = `${BASE_URL}suppliers/hs-doc-records/`; //
export const getTabs = `${BASE_URL}suppliers/hs-doc-records/tabs`; // View tabs available to create templates
export const getHsDocRecordsLight = `${BASE_URL}suppliers/hs-doc-records/list/records`; // Lightweight list for selects

// H&S Categories
export const getHsCategories = `${BASE_URL}suppliers/hs-categories`;
export const createHsCategory = `${BASE_URL}suppliers/hs-categories/create`;

// H&S Document Records (Templates)
export const createHsDocumentRecord = `${BASE_URL}suppliers/hs-doc-records/store`;

// H&S Questions
export const getHsQuestions = `${BASE_URL}suppliers/hs-question/index`;
export const createHsQuestions = `${BASE_URL}suppliers/hs-question/create`;
export const assignHsQuestions = `${BASE_URL}suppliers/hs-question/assing-questions`;

// H&S Question Options
export const getHsQuestionOptions = `${BASE_URL}suppliers/hs-question-options`;
export const createHsQuestionOptions = `${BASE_URL}suppliers/hs-question-options/create`;

// Purchasing AI
export const getPoAi = `${BASE_URL}openai/email-orders/po-order/`;

//Reports
export const salesFilter = `${BASE_URL}suppliers/product-history/group-quantity`;
export const checkConversions = `${BASE_URL}suppliers/product-history/master-product-filter`;
export const cisReports = `${BASE_URL}suppliers/orders/delivery-report
`;
export const cisCSV = `${BASE_URL}suppliers/orders/delivery-report-csv`;
export const csvVat = `${BASE_URL}suppliers/orders/export/csv-vat`;
export const csvLine = `${BASE_URL}suppliers/orders/export/csv-basic`;
export const csvVatSage = `${BASE_URL}suppliers/orders/export/csv-vat-sage`;

// Performance
export const performanceUrl = `${BASE_URL}suppliers/fleet-checks/info-driver-records`;

// Finance
export const getDetailsPurchases = `${BASE_URL}suppliers/purchasing/invoices/get-purchase-orders`;
export const mergeApprove = `${BASE_URL}suppliers/purchasing/invoices/purchase-orders`;

//Country
export const getCountriesUrl = `${BASE_URL}public/countries/all`;

//Allergens
export const getAllergensUrl = `${BASE_URL}suppliers/allergens/index`;
export const updateAllergens = `${BASE_URL}suppliers/master-products-allergens/upsert`;
export const getAllergensMasterProduct = `${BASE_URL}suppliers/master-products-allergens/show`;

//AI - Master Product
export const updateSpecifications = `${BASE_URL}suppliers/products-specifications/update`;
export const createSpecifications = `${BASE_URL}suppliers/products-specifications`;
export const getSpecifications = `${BASE_URL}suppliers/products-specifications`;

export const generateSpecContentAI = `${BASE_URL}suppliers/products-specifications/generate/`;

// Transport – Fleet
export const getActiveVansUrl = `${BASE_URL}suppliers/fleet`;

// Transport – Fleet – Van Logs
export const getVanLogsUrl = `${BASE_URL}suppliers/fleet/van-logs`;

// Transport – Shift Allocation
export const getDriversShiftAllocationUrl = `${BASE_URL}suppliers/logistic-routes/shift-allocation/drivers`;

export const getVansShiftAllocationUrl = `${BASE_URL}suppliers/logistic-routes/shift-allocation/vans`;
export const putVanShiftAllocationUrl = `${BASE_URL}suppliers/logistic-routes/shift-allocation/status-van`;

export const getRoutesShiftAllocationUrl = `${BASE_URL}suppliers/logistic-routes/shift-allocation/routes`;
export const deleteRouteShiftAllocationUrl = `${BASE_URL}suppliers/logistic-routes/shift-allocation`;
export const updateLogisticsRouteUrl = `${BASE_URL}suppliers/logistic-routes/shift-allocation/update`;

// Products
export const getAllProductsUrl = `${BASE_URL}suppliers/products-suppliers/all-products-select`;

// Analytics Dashboard
export const dashboardUrl = `${BASE_URL}suppliers/dashboard`;

// Rules inbox
export const emailRulesUrl = `${CHAT_BASE_URL}/node/api/email-rules/`;


// Rules AI (same rule shape as inbox rules; save replaces the whole rules file)
export const aiRulesGetUrl = `${CHAT_BASE_URL}/ai/util/api/rules/get/`;
export const aiRulesSaveUrl = `${CHAT_BASE_URL}/ai/util/api/rules/save/`;
